import React, {useState, useEffect} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import Input from '@mui/joy/Input';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Textarea from '@mui/joy/Textarea';
import { NumericFormat } from 'react-number-format';
import Checkbox from '@mui/joy/Checkbox';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
import FundService from "../../../services/fundService";
import { useNavigate } from "react-router-dom";


function ModalViewDayFCI( {handleOpen, isOpen, selected, setSelected, fundId, refresh}) {

    const navigate = useNavigate();

    const doSave = function(){
        FundService.putFundOperation(selected.id, selected)
            .then((response) => {
                toast.success('Operación actualizada!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            })
            .catch((error) => {
                if(error.response.status !== 401){
                    Swal.fire({
                        title: 'Ooops?',
                        text: error.response.data.errors[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            })
            .finally(() => { 
                handleOpen(false)
                refresh()
            })
    }
    
    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  Operación: #{fundId}</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Nro. Comitente</FormLabel>
                                {selected.account !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.account_model.account} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={8}>
                            <FormControl>
                                <FormLabel className="form-labels">Comitente</FormLabel>
                                {selected.account !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.account_model.name} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={3}>
                            <FormControl>
                                <FormLabel className="form-labels">Tipo de Operación</FormLabel>
                                {selected.market !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.operation_type.name} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Fondo</FormLabel>
                                {selected.segment !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.fund.name} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={3}>
                            <FormControl>
                                <FormLabel className="form-labels">Moneda</FormLabel>
                                <Input size="md" placeholder="" disabled={true} value={selected.currency.name} />
                            </FormControl>
                        </Grid>
                        <Grid xs={3}>
                            <FormControl>
                                <FormLabel className="form-labels">Plazo</FormLabel>
                                <Input size="md" placeholder="" disabled={true} value={selected.settlement_term.name} />
                            </FormControl>
                        </Grid>
                        <Grid xs={3}>
                            <FormControl>
                                <FormLabel className="form-labels">Tipo</FormLabel>
                                {selected.settlement_term !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.investment_mode.name} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={3}>
                            <FormControl>
                                <FormLabel className="form-labels">Monto (
                                    {
                                        <NumericFormat 
                                            displayType="text" 
                                            className="form-control" 
                                            value={selected.amount} 
                                            decimalScale={2}
                                            allowLeadingZeros 
                                            thousandSeparator="." 
                                            decimalSeparator="," 
                                            renderText={(value) => <b>{value}</b>}
                                        />
                                    } )</FormLabel>
                                <NumericFormat 
                                    displayType="input" 
                                    className="form-control" 
                                    value={selected.amount / selected.price} 
                                    decimalScale={2} 
                                    allowLeadingZeros 
                                    thousandSeparator="." 
                                    decimalSeparator="," 
                                    disabled={true}
                                /> 
                            </FormControl>
                        </Grid>
                        <Grid xs={3}>
                            <FormControl>
                                <FormLabel className="form-labels">Cantidad (
                                    {
                                        <NumericFormat 
                                            displayType="text" 
                                            className="form-control" 
                                            value={selected.qty} 
                                            decimalScale={0}
                                            allowLeadingZeros 
                                            thousandSeparator="." 
                                            decimalSeparator="," 
                                            renderText={(value) => <b>{value}</b>}
                                        />
                                    } )</FormLabel>
                                <NumericFormat 
                                    displayType="input" 
                                    className="form-control" 
                                    value={selected.qty * selected.price} 
                                    decimalScale={0}
                                    allowLeadingZeros 
                                    thousandSeparator="." 
                                    decimalSeparator="," 
                                    disabled={true}
                                /> 
                            </FormControl>
                        </Grid>
                        <Grid xs={3}>
                            <FormControl>
                                <FormLabel className="form-labels">Valor Cuotaparte</FormLabel>
                                <Input type="number" size="md" placeholder="" 
                                   value={selected.price} 
                                    slotProps={{
                                        input: {
                                            min: 0,
                                        },
                                    }} 
                                    onChange={(event) => {setSelected({...selected, price: event.target.value}); }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={3}>
                            <FormControl>
                                <FormLabel className="form-labels">ACDI</FormLabel>
                                <Checkbox size="md" color="neutral" checked={selected.is_acdi} disabled={true} /> 
                            </FormControl>
                        </Grid>
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Observciones</FormLabel>
                                <Textarea
                                    disabled={true}
                                    value={selected.observations}
                                    minRows={4}
                                    maxRows={4}
                                />
                            </FormControl>
                        </Grid>
                        
                    </Grid> 
                </DialogContent>
                <Divider />
                <DialogActions>
                    {selected.operation_state_id === 2 && <button type="button" className="btn btn-outline-info"  onClick={() => doSave()}> Guardar </button>  }
                    <button type="button" className="btn btn-outline-secondary"  onClick={() => handleOpen(false)}> Cerrar </button>                    
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalViewDayFCI;